<template>
	<div>
		<header class="header-area header-transparent-bar sticky-bar">
		    <div class="container">
		        <div class="row align-items-center">
		            <div class="col-lg-3 col-md-6 col-4">
		                <div class="logo d-flex" style="align-items: center;">
							<router-link :to="{ path: '/' }">	
		                        <img class="white-logo" src="@/assets/images/logo/logo.png" alt="logo">
		                        <img class="black-logo" src="@/assets/images/logo/logo.png" alt="logo">
		                    </router-link>
		                </div>
		            </div>
		            <div class="col-lg-6 d-none d-lg-block d-flex justify-content-center">
		                <div class="main-menu text-center">
		                    <nav>
		                        <ul>
		                            <li><router-link :to="{ path: '/' }">首页</router-link></li>
		                            <li><router-link :to="{ path: '/project' }">案例</router-link></li>
		                            <li><router-link :to="{ path: '/specialColumn' }">专栏</router-link></li>
		                            <li><router-link :to="{ path: '/product' }">产品</router-link></li>
		                            <li><router-link :to="{ path: '/show' }">展厅</router-link></li>
		                            <li><router-link :to="{ path: '/exhibition' }">展会</router-link></li>
									<li><router-link :to="{ path: '/promotions' }">找优惠</router-link></li>
									<li><router-link :to="{ path: '/contant' }">联系我们</router-link></li>
		                        </ul>
		                    </nav>
		                </div>
		            </div>
		            <div class="col-lg-3 col-md-6 col-8">
		                <div class="header-action-wrap">
							<div class="header-action-style">
								<router-link :to="{ path: '/appDownload' }">筑壳APP</router-link>
							</div>
		                    <div class="header-action-style header-search-1">
		                        <span class="search-toggle" style="color: #FFFFFF;">
									<a class="header-aside-button"><i class="dlicon ui-1_zoom s-open" @click="showsearch"></i></a>
		                        </span> 
		                    </div>
		                    <div class="header-action-style">
		                        <a class="header-aside-button phoneshow"><i class="dlicon ui-3_menu-left" @click="showaside(1)"></i></a>
		                    </div>
							<div class="header-action-style">
								<a v-if="!isLogin" class="header-aside-button2" @click="showLogin">用户登录</a>
								<Dropdown v-else @on-click="handleClick">
									<a class="header-aside-button2">{{ userInfo.nickname }}</a>
									<DropdownMenu slot="list">
										<DropdownItem name="usercenter"><Icon type="ios-contact-outline" class="iconImg" />个人中心</DropdownItem>
										<DropdownItem name="logout"><Icon type="ios-log-out" class="iconImg" />退出登录</DropdownItem>
									</DropdownMenu>
								</Dropdown>
							</div>
		                </div>
		            </div>
		        </div>
		    </div>
		</header>
		
		<!-- aside start -->
		<div class="header-aside-active">
		    <div class="header-aside-wrap">
		        <a class="aside-close"><i class="dlicon ui-1_simple-remove" @click="showaside(0)"></i></a>
		        <div class="header-aside-content">
		            <div class="mobile-menu-area">
		                <div class="mobile-menu-wrap">
		                    <!-- mobile menu start -->
		                    <div class="mobile-navigation">
		                        <!-- mobile menu navigation start -->
		                        <nav>
		                            <ul class="mobile-menu">
		                                <li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/project' }">案例</router-link></li>
		                                <li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/specialColumn' }">专栏</router-link></li>
		                                <li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/product' }">产品</router-link></li>
		                                <li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/show' }">展厅</router-link></li>
		                                <li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/exhibition' }">展会</router-link></li>
										<li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/promotions' }">找优惠</router-link></li>
		                                <li class="menu-item-has-children" @click="showaside(0)"><router-link :to="{ path: '/contant' }">联系我们</router-link></li>
		                            </ul>
		                        </nav>
		                        <!-- mobile menu navigation end -->
		                    </div>
		                    <!-- mobile menu end -->
		                </div>
		            </div>
		            <div class="header-aside-menu">
		                <nav>
		                    <ul>
								<li @click="showaside(0)"><router-link :to="{ path: '/project' }">案例</router-link></li>
								<li @click="showaside(0)"><router-link :to="{ path: '/specialColumn' }">专栏</router-link></li>
								<li @click="showaside(0)"><router-link :to="{ path: '/product' }">产品</router-link></li>
								<li @click="showaside(0)"><router-link :to="{ path: '/show' }">展厅</router-link></li>
								<li @click="showaside(0)"><router-link :to="{ path: '/exhibition' }">展会</router-link></li>
								<li @click="showaside(0)"><router-link :to="{ path: '/contant' }">联系我们</router-link></li>
		                    </ul>
		                </nav>
		            </div>
		            <div class="aside-banner-wrap" @click="showaside(0)">
		                <router-link :to="{ path: '/appDownload' }">
		                    <img src="@/assets/images/banner/banner-1.jpg" alt="banner">
		                    <div class="aside-banner-add-content">
		                        <h5>筑壳APP</h5>
		                        <p>建筑设计装饰内容发现中心</p>
		                    </div>
		                </router-link>
		            </div>
		            <div class="aside-contact-info">
		                <ul>
		                    <li><i class="dlicon ui-1_email-84"></i>0755-83065200</li>
		                    <li><i class="dlicon tech-2_rotate"></i>13652413182</li>
		                    <li><i class="dlicon ui-1_home-minimal"></i>深圳市龙岗区坂田街道坂田国际中心A座1508号</li>
		                </ul>
		            </div>
		            <div class="copyright">
		                <p>筑壳(深圳)科技有限公司 | 备案号：粤ICP备2022044914号-1</p>
		            </div>
		        </div>
		    </div>
		</div>
		
		<login ref="template"></login>
		
		<transition name="el-fade-in-linear">
		    <div class="search_lock" v-show="searchshow" @click.stop="searchshow = false">
				<div class="search_wrp" style="margin-top: 300px;" @click.stop>
					<div>
						<span class="meun_text" :class="item.id == activeIndex?'active':''" v-for="(item,index) in meun" :key="item.id" @click="activeIndex = item.id">{{item.name}}</span>
					</div>
					<div class="entry_text">
						<input v-model="input" @keyup.enter="toSearch(input)" placeholder="请输入内容" />
						<i class="el-icon-search" @click="toSearch(input)"></i>
					</div>
					<div class="hot_sc">
						<span class="hot_title">热门搜索</span>
						<div class="key_blk">
							<span class="key_text" v-for="(item,index) in hotKeyword" :key="index">
								<span style="cursor: pointer;" @click="toSearch(item)">{{item}}</span>
							</span>
						</div>
					</div>
				</div>	
		    </div>
		</transition>
		
	</div>
</template>

<script>
import { getCookies, removeCookies } from '@/libs/util'
import { logout, hotKeyword } from "@/api"
export default {
   name: 'app',
   inject: ['reload'],
   data() {
		return { 
			nameInfo: '',
			searchshow: false,
			input:'',
			hotKeyword:[],
			meun: [{
				id: 1,
				name: '案例'
			},
			{
				id: 3,
				name: '公司'
			},
			{
				id: 2,
				name: '产品'
			},
			{
				id: 4,
				name: '展厅'
			},
			{
				id: 5,
				name: '展会'
			}],
			activeIndex: 1
		}
	},
	computed: {
		isLogin() {
		    return getCookies("webtoken");
		},
		userInfo() {
			let obj = this.$store.state.app.userInfo || {};
			if(obj.zk_id) {
				return obj
			} else {
				removeCookies("webtoken")
			}
		}
	},
	mounted() {
		this.getHotKeyword()
	},
	methods:{
		
		goRouter(url) {
			this.$router.push({path: url})
		},
		
		getHotKeyword() {
			hotKeyword({
				page:1,
				limit:15
			}).then(res => {
				this.hotKeyword = res.data
			})
		},
		
		showLogin() {
			this.$refs.template.isTemplate = true
		},
		handleClick(name) {
		  switch (name) {
			case "logout":
			  this.logout();
			  break;
			case "usercenter":
			  this.usercenter();
			  break;
			case "message":
			  this.message();
			  break;
		  }
		},
		usercenter() {
			this.$router.push("/usercenter");
		},
		logout() {
		  let that = this;
		  this.$Modal.confirm({
			title: "退出登录确认",
			content: "您确定退出当前账户吗？",
			onOk() {
			  that.$Message.success("您已成功退出");
			  localStorage.clear();
			  removeCookies("webtoken");
			  removeCookies("webexpires_time");
			  removeCookies("uuid");
			  that.$router.push("/");
			  that.reload()
			},
		  });
		},
		
		toSearch(keywords) {
			if(keywords.trim()=='') {
				alert('请输入搜索内容')
				return false
			}
			this.searchshow = false
			let routeUrl = this.$router.resolve({
				path: '/search',
				query: {
				  keyword: keywords,
				  stype: this.activeIndex
				}
			  })
			  window.open(routeUrl.href, '_blank')
			  this.input = ''
			  this.searchshow = false
		},
		
		// 右框显示隐藏
		showaside(status) {
			if(status) {
				$('.header-aside-active').addClass('inside');
			} else {
				$('.header-aside-active').removeClass('inside');
			}
		},
		// 搜索框显示隐藏
		showsearch() {
			this.searchshow = true
		},
	
	},
}
</script>

<style scoped>
	.search_lock {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(255,255,255,.98);
		z-index: 1000;
	}
	.search_wrp {
		margin: 0 auto;
		padding: 20px 0;
		max-width: 750px;
		width: 90%;
	}
	.hot_title {
		font-size: 16px;
		color: #333;
		margin-bottom: 15px;
		display: block;
		font-weight: bold;
	}
	.meun_text {
		font-size: 20px;
		color: #999;
		margin-right: 20px
	}
	.meun_text:hover {
		cursor:pointer
	}
	.active{
		color: #333;
		font-weight: bold;
	}
	.entry_text {
		position: relative;
		height: 64px;
		border-bottom: 1px solid #999;
		margin: 10px 0 30px;
	}
	.entry_text input{
		line-height: 64px;
		height: 64px;
		border: none;
		background: none;
		font-size: 18px;
		width: 100%;
		padding-right: 50px;
		box-sizing: border-box;
	}
	.entry_text i{
		position: absolute;
		right: 0;
		top: 0;
		height: 100%;
		line-height: 64px;
		width: 50px;
		text-align: center;
		cursor: pointer;
		font-size: 24px;
		color: #0f0f0f;
	}
	.key_text span {
		display: inline-block;
		padding: 9px 10px;
		margin: 5px 6px 5px 0;
		color: #333;
		font-weight: bold;
		margin-left: 0;
		border: 1px solid #a8a8a8;
		font-size: 14px;
		transition: 0.3s;
		-webkit-transition: 0.3;
		vertical-align: middle;
	}
	.key_text span:hover{
		background: #333 !important;
		color: white !important;
	}
	ol,ul {
		padding-left: 0 !important;
	}
</style>
